import { IIndexable } from '../model/IIndexable';
import { ResultadoData } from '../model/ResultadoData';
import { productoDataMapping } from './productoDataMapping';

export function resultadoDataMapping(item: IIndexable) {
  return new ResultadoData(item.products?.map((prod: IIndexable) => productoDataMapping(prod)), item.title, item.icon, item.comments);
}
